import { NavLink, Route, Routes } from "react-router-dom";
import { APP_NAME, IAP, NAV } from "@pms/shared";
import Home from "./pages/Home";
import People from "./pages/People";
import Pyramid from "./pages/Pyramid";
import Projects from "./pages/Projects";
import Budget from "./pages/Budget";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Tos from "./pages/Tos";
import Privacy from "./pages/Privacy";

const linkClass = ({ isActive }: { isActive: boolean }) => (isActive ? "active" : undefined);

export default function App() {
  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="brand">
          <div className="brand-mark">PMS</div>
          <div>
            <h1>{APP_NAME}</h1>
            <p>Phase 0 scaffold</p>
          </div>
        </div>
        <nav className="nav">
          <NavLink to="/" end className={linkClass}>
            {NAV.home}
          </NavLink>
          <NavLink to="/people" className={linkClass}>
            {NAV.people}
          </NavLink>
          <NavLink to="/pyramid" className={linkClass}>
            Org pyramid
          </NavLink>
          <NavLink to="/projects" className={linkClass}>
            {NAV.projects}
          </NavLink>
          <NavLink to="/budget" className={linkClass}>
            {NAV.budget}
          </NavLink>
          <NavLink to="/reports" className={linkClass}>
            {NAV.reports}
          </NavLink>
          <div className="section">Account</div>
          <NavLink to="/settings" className={linkClass}>
            {NAV.settings} / AI
          </NavLink>
        </nav>
        <div className="footer-links">
          <div className="badge muted" style={{ marginBottom: 8 }}>
            User ${IAP.userPriceUsdYear}/yr · Admin ${IAP.adminPriceUsdYear}/yr
          </div>
          <NavLink to="/tos">Terms</NavLink>
          <NavLink to="/privacypolicy">Privacy</NavLink>
        </div>
      </aside>
      <main className="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/people" element={<People />} />
          <Route path="/pyramid" element={<Pyramid />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/budget" element={<Budget />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/tos" element={<Tos />} />
          <Route path="/privacypolicy" element={<Privacy />} />
        </Routes>
      </main>
    </div>
  );
}
